export default __webpack_public_path__ + "static/media/patterns-no-6.e2df13db.mid";